import Billing from "./billing";
import InvoicePage from "./pages/InvoicePage";
import CompanyBillingDashboard from "./CompanyBillingDashboard";
import CompanyFacilitiesView from "./CompanyFacilitiesView";

const billingRoutes = [
  {
    path: "/core/billing",
    element: <CompanyBillingDashboard />,
  },
  {
    path: "/core/billing/company/:companyId",
    element: <CompanyFacilitiesView />,
  },
  {
    path: "/core/billing/invoice/:invoiceId",
    element: <InvoicePage />,
  },
  {
    path: "/core/billing/old",
    element: <Billing />,
  },
];

export default billingRoutes;
